import { motion } from 'framer-motion';
import { Scale, CheckCircle, Clock, Shield } from 'lucide-react';

const reasons = [
  {
    icon: Scale,
    title: 'Spécialisation notariale',
    description:
      'Nous connaissons les spécificités des ventes notariales et adaptons chaque intervention en conséquence.',
  },
  {
    icon: CheckCircle,
    title: 'Process clair',
    description:
      'Un fonctionnement structuré et transparent, de la commande à la livraison du dossier.',
  },
  {
    icon: Clock,
    title: 'Gain de temps',
    description:
      'Libérez vos équipes des tâches opérationnelles pour vous concentrer sur votre cœur de métier.',
  },
  {
    icon: Shield,
    title: 'Partenaire fiable',
    description:
      'Équipe professionnelle, assurée et formée aux exigences du secteur notarial.',
  },
];

export function WhyUs() {
  return (
    <section id="pourquoi" className="py-24 bg-cream/30">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-50 text-gold-700 text-sm font-medium border border-gold-200 mb-6"
          >
            Nos engagements
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl font-display font-bold text-navy-600 mb-6"
          >
            Pourquoi choisir{' '}
            <span className="gradient-text">VISINOT</span> ?
          </motion.h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <motion.div
              key={reason.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center group"
            >
              <div className="w-16 h-16 rounded-2xl bg-white shadow-sm mx-auto flex items-center justify-center mb-5 group-hover:shadow-md group-hover:scale-105 transition-all">
                <reason.icon className="w-8 h-8 text-gold-600" />
              </div>
              <h3 className="text-lg font-display font-semibold text-navy-600 mb-3">
                {reason.title}
              </h3>
              <p className="text-navy-300 leading-relaxed text-sm">{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
